import React from "react";
import { Button, StatusBadge, Text } from "@zorni/components-lib";

import { USER_STATUS } from "../../../../common/model/enum";
import { mapStatusToBadge } from "../utils/mappers";
import styles from "./UserTable.module.css";

const UserTable = ({ users, onEdit, onRelaunch }) => {
  if (!users.length) {
    return (
      <div className={styles.emptyState}>
        <Text size="sm" color="muted">
          Aucun utilisateur a afficher.
        </Text>
      </div>
    );
  }

  return (
    <div className={styles.tableWrapper}>
      <table className={styles.table}>
        <thead className={styles.thead}>
          <tr>
            <th>Prenom</th>
            <th>Nom</th>
            <th>Email</th>
            <th>Statut</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {users.map((user) => {
            const status = mapStatusToBadge(user.status);

            return (
              <tr key={user.id}>
                <td>{user.firstName}</td>
                <td>{user.lastName || user.name}</td>
                <td>{user.email}</td>
                <td>
                  <StatusBadge
                    iconName={status.iconName}
                    iconPosition="left"
                    label={status.label}
                    type={status.type}
                    size="small"
                  />
                </td>
                <td>
                  <div className={styles.actions}>
                    {user.status === USER_STATUS.ACTIVATION_IN_PROGRESS ? (
                      <Button
                        size="small"
                        variant="primary"
                        background="rgba(245,158,11,.15)"
                        hoverColor="#ffff"
                        textColor="#f59e0b"
                        iconName="iconSend"
                        iconPosition="left"
                        label="Relancer"
                        onClick={() => onRelaunch(user)}
                      />
                    ) : (
                      <Button
                        size="small"
                        variant="primary"
                        background="rgba(28,195,178,.12)"
                        hoverColor="#ffff"
                        textColor="#1cc3b2"
                        iconName="iconPenToSquare"
                        iconPosition="left"
                        label="Modifier"
                        onClick={() => onEdit(user)}
                      />
                    )}
                  </div>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default UserTable;
